import { CHANGE_PAGE_ID, RESET_STATE } from './constants';

export function changePageIdAction(pageId) {
  return {
    type: CHANGE_PAGE_ID,
    pageId,
  };
}

export function resetStateAction() {
  return {
    type: RESET_STATE,
  };
}
